"use strict";

var _undefined = require("../function/noop")(); // Support ES3 engines

module.exports = function (val) {
 return (val !== _undefined) && (val !== null);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es5-ext/object/is-value.js
 ** module id = 730
 ** module chunks = 0
 **/